var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgShopping(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6951 23H4.67598C4.28074 23 3.96871 22.6607 4.00251 22.2667L5.32474 6.9018C5.35464 6.55207 5.64717 6.28424 5.99821 6.28424H18.3728C18.7239 6.28424 19.0164 6.55207 19.045 6.9018L20.3685 22.2667C20.401 22.6607 20.0916 23 19.6951 23Z",
    stroke: "black",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84512 8.0389V4.34003C8.84512 2.49515 10.3403 1 12.1852 1C14.03 1 15.5265 2.49515 15.5265 4.34003V8.25212",
    stroke: "black",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0817 9.56314C10.0817 8.88058 9.52788 8.32672 8.84531 8.32672C8.16144 8.32672 7.60889 8.88058 7.60889 9.56314C7.60889 10.2457 8.16144 10.7996 8.84531 10.7996C9.52788 10.7996 10.0817 10.2457 10.0817 9.56314Z",
    stroke: "black",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.7628 9.56314C16.7628 8.88058 16.2089 8.32672 15.5264 8.32672C14.8425 8.32672 14.2899 8.88058 14.2899 9.56314C14.2899 10.2457 14.8425 10.7996 15.5264 10.7996C16.2089 10.7996 16.7628 10.2457 16.7628 9.56314Z",
    stroke: "black",
    strokeLinecap: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShopping);
export default __webpack_public_path__ + "static/media/shopping.92c1a6f9.svg";
export { ForwardRef as ReactComponent };